import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { RAZORPAY_PAYMENT_LINK } from "@/config";
import {
  Hero,
  Lead,
  CertificateNote,
  Villain,
  IndianSection,
  Mechanism,
  NotHypnosis,
  WillLearn,
  Modules,
  Bonuses,
  GalleryStrip,
  Testimonials,
  Guarantee,
  Pricing,
  CloseSection,
  PSSection,
  FAQ,
  Footer,
} from "@/components/landing/Sections";

export default function Landing() {
  const openCheckout = () => {
    // Meta Pixel: tell it someone started checkout, right before we send
    // them to the Razorpay payment page.
    if (typeof window !== "undefined" && window.fbq) {
      window.fbq("track", "InitiateCheckout");
    }
    window.open(RAZORPAY_PAYMENT_LINK, "_blank", "noopener,noreferrer");
  };

  useEffect(() => {
    document.title =
      "Learn Hypnosis — Heal Yourself, Help Your Family (₹3,500)";
  }, []);

  return (
    <div
      data-testid="landing-page"
      className="relative bg-black text-[#F5F2EA] overflow-x-hidden"
    >
      <Hero onCta={openCheckout} />
      <Lead />
      <CertificateNote />
      <Villain />
      <IndianSection />
      <Mechanism />
      <NotHypnosis />
      <WillLearn />
      <Modules onCta={openCheckout} />
      <Bonuses />
      <GalleryStrip />
      <Testimonials />
      <Guarantee onCta={openCheckout} />
      <Pricing onCta={openCheckout} />
      <CloseSection onCta={openCheckout} />
      <PSSection onCta={openCheckout} />
      <FAQ />
      <Footer />

      {/* Sticky bottom bar - desktop AND mobile (like reference site) */}
      <motion.div
        initial={{ y: 100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 1.2, duration: 0.6 }}
        className="fixed bottom-0 left-0 right-0 z-40 bg-[#F89C03] border-t border-[#000000]/10 shadow-[0_-10px_40px_rgba(248,156,3,0.25)]"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between gap-3">
          <div className="flex-1 sm:flex-initial text-black text-sm sm:text-base font-medium text-center sm:text-left">
            Get instant lifetime access at{" "}
            <span className="font-bold">₹3,500/-</span>
          </div>
          <Button
            data-testid="cta-sticky-mobile"
            onClick={openCheckout}
            className="bg-black hover:bg-[#1a1a1a] text-white font-semibold tracking-wide rounded-full px-5 sm:px-7 h-11 cta-shine shrink-0"
          >
            GET IT NOW
          </Button>
        </div>
      </motion.div>
    </div>
  );
}
